import React, { useCallback } from 'react';
import { keyCodes } from '@yme/utils/constants';
import { ListItemStyled } from './styled';
export function ListItem({ onOptionClicked, setIsListOpen, data }) {
    const { label, value, index, array, isFlexible, activeItem, icon } = data;
    const onOptionPressed = useCallback((e, { label, value, index, array }) => {
        if (e.key === keyCodes.ENTER) {
            onOptionClicked({
                label,
                value,
            });
        }
        if (index === array.length - 1 && e.key === keyCodes.TAB && !e.shiftKey) {
            setIsListOpen(false);
        }
        if (e.key === keyCodes.ESCAPE) {
            setIsListOpen(false);
        }
    }, [onOptionClicked, setIsListOpen]);
    return (React.createElement(ListItemStyled, { onClick: () => onOptionClicked({
            label,
            value,
        }), onKeyDown: (e) => onOptionPressed(e, {
            label,
            value,
            index,
            array,
        }), isFlexible: isFlexible, isActiveItem: value === activeItem, tabIndex: 0 },
        icon,
        label));
}
